import React, { useContext } from 'react'
import styled from 'styled-components'
import { PermissionsContext } from './Uploads'

export default function UploadButton({
    text = 'Upload',
    icon = 'fa fa-upload',
    setShowModal
}: {
    text?: string
    icon?: string
    setShowModal: (value: boolean) => void
}) {
  
    const permissions = useContext(PermissionsContext)

    if(!permissions.uploadPrivateFile && !permissions.uploadPublicFile){
      return null
    }
  
    return (
        <Container>
            <span className="upload-input" hidden={false}>
                <button className={'btn btn-primary'} onClick={() => setShowModal(true)} disabled={false}>
                    <i className={icon} />
                    <span className="upload-status">{text}</span>
                </button>
            </span>
        </Container>
    )
}

const Container = styled.div`
    padding: 1rem 0;

    .file-dropzone {
        position: relative !important;
    }
`
